import { joinSgcmMsSite } from '../join/public';
import type { GetMemberLoginUrl } from './types';

export const getMemberLoginUrl: GetMemberLoginUrl = ({
  key,
}) => {
  const url = joinSgcmMsSite('/member/login');

  if (key) {
    url.searchParams.set('key', key);
  }

  return url;
};
